import { useI18n } from "@/context/I18nContext";
// Marques vectorielles à fond transparent (aucun bitmap).

export function BvdLogo({ className = "w-8 h-8 text-blue-700" }) {
  return (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
      <path d="M16 3L4 8v8c0 7.33 5.12 14.19 12 16 6.88-1.81 12-8.67 12-16V8L16 3z"
        fill="currentColor" fillOpacity="0.1" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M16 10v12M10 16h12" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

export function BrandMark({ compact = false }) {
  const { t } = useI18n();
  return (
    <div className="flex items-center gap-2.5">
      <BvdLogo className="w-7 h-7 text-[#0B2A5B] shrink-0" />
      <div className="leading-tight">
        <div className="font-head font-bold text-[#0B2A5B] text-[15px] tracking-tight">BVD-Ituri</div>
        {!compact && <div className="text-[10px] font-medium uppercase tracking-[0.12em] text-slate-500">{t("brand_tagline")}</div>}
      </div>
    </div>
  );
}

// Logotype fhi360 vectorisé : lettrage bleu nuit, arc orange encerclant « 360 », ouvert en haut à gauche.
export function Fhi360Logo({ className = "h-6 w-auto", dark = false }) {
  return (
    <svg viewBox="0 0 230 124" className={className} role="img" aria-label="fhi360" style={{ overflow: "visible" }}>
      <text x="4" y="82" fontFamily="'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif" fontWeight="700" fontSize="58" letterSpacing="-2.5" fill={dark ? "#FFFFFF" : "#1B2A4A"}>fhi</text>
      <text x="92" y="82" fontFamily="'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif" fontWeight="700" fontSize="58" letterSpacing="-2.5" fill={dark ? "#FFFFFF" : "#1B2A4A"}>360</text>
      <path d="M150 6 A56 56 0 0 1 150 118" fill="none" stroke="#F04E23" strokeWidth="8" strokeLinecap="round" />
    </svg>
  );
}

export function Fhi360Badge({ className = "" }) {
  const { t } = useI18n();
  return (
    <div className={`flex items-center justify-between gap-2 px-2.5 py-1.5 rounded-md border border-slate-200 bg-white ${className}`} aria-label="FHI 360 Partner">
      <Fhi360Logo className="h-7 w-auto" />
      <span className="text-[9px] font-medium uppercase tracking-[0.12em] text-slate-500">{t("brand_partner")}</span>
    </div>
  );
}
